import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { MyTaskContent, MyTaskListResponse, MyTaskSearchCriteria } from '../../models';
import { DashboardAction, DashboardActionTypes } from '../actions/dashboard.actions';

export interface MyTaskState extends EntityState<MyTaskContent> {
  isLoading: boolean;
  criteriaObject: MyTaskSearchCriteria;
  totalElements: number;
  totalPages: number;
  auditLogs: any;
  selected: MyTaskListResponse | null;
}

export const adapter: EntityAdapter<MyTaskContent> = createEntityAdapter<MyTaskContent>();

export const initialMyTaskListState: MyTaskState = adapter.getInitialState({
  isLoading: false,
  criteriaObject: {
    page: 0,
    size: 20
  },
  totalElements: 0,
  totalPages: 0,
  auditLogs: null,
  selected: null
});

export function myTaskReducers(state = initialMyTaskListState, action: DashboardAction): MyTaskState {
  switch (action.type) {
    case DashboardActionTypes.TASKS_BY_ROLE_LIST_REQUEST:
      return {
        ...state,
        criteriaObject: action.payload === null ? { ...state.criteriaObject } : action.payload
      };
    case DashboardActionTypes.TASKS_BY_ROLE_LIST_RESPONSE:
      return adapter.setAll(action.payload.content, {
        ...state,
        criteriaObject: {
          ...state.criteriaObject,
          page: action.payload.page,
          size: action.payload.size
        },
        totalElements: action.payload.totalElements,
        totalPages: action.payload.totalPages
      });
    default: {
      return state;
    }
  }
}

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
